<router-outlet></router-outlet>
<!-- <ng-progress
    [positionUsing]="'marginLeft'"
    [direction]="'leftToRightIncreased'"
    [color]="'#009DA0'"
    [trickleSpeed]="500" 
    [thick]="true" 
    [ease]="'easeInSine'"
></ng-progress> -->